module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fff",
      "padding": "20px",
      "margin-bottom": "8px",
      "border-radius": "10px"
    }
  }, [_c('div', {
    staticClass: "flex justify-between align-center toptitle"
  }, [_c('div', {
    staticClass: "topleft"
  }, [_vm._v("已获政策支持")]), _vm._v(" "), _c('div', {
    staticClass: "topright"
  }, [_vm._v("申请补贴总金额："), _c('span', {
    staticClass: "rione"
  }, [_vm._v(_vm._s(_vm.supporttotal_money ? _vm.supporttotal_money : 0) + "万元")])])]), _vm._v(" "), _c('div', [_vm._m(0), _vm._v(" "), (_vm.newlist) ? _c('div', [_vm._l((_vm.newlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text1 text-center text-center",
      staticStyle: {
        "width": "40px"
      }
    }, [_c('div', {
      staticClass: "response text-center"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 justify-center text-center"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.dynamic ? item.dynamic : "--") + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 cpoint justify-center text-center",
      staticStyle: {
        "color": "#0070c0"
      },
      on: {
        "click": function($event) {
          return _vm.toout(item.name_href)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.entry_name ? item.entry_name : '--') + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 justify-center text-center"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.topic_name ? item.topic_name : '--') + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 justify-center  width-80",
      staticStyle: {
        "flex": "none"
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.year ? item.year : '--') + "\n\t\t\t\t")]), _vm._v(" "), (!item.showz) ? _c('div', {
      staticClass: "box5_text2 justify-center",
      staticStyle: {
        "min-width": "250px",
        "justify-content": "space-around",
        "text-align": "center"
      }
    }, [_c('div', {
      staticClass: "cpoint",
      staticStyle: {
        "margin": "8px 10px",
        "width": "50%"
      },
      on: {
        "click": function($event) {
          return _vm.toout(item.province_support_href)
        }
      }
    }, [_vm._v("省："), _c('span', {
      staticStyle: {
        "color": "#0070c0"
      }
    }, [_vm._v(_vm._s(item.province_support ? item.province_support : '--'))])]), _vm._v(" "), _c('div', {
      staticClass: "cpoint",
      staticStyle: {
        "margin": "8px 10px",
        "width": "50%"
      },
      on: {
        "click": function($event) {
          return _vm.toout(item.city_support_href)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t市："), _c('span', {
      staticStyle: {
        "color": "#0070c0"
      }
    }, [_vm._v(_vm._s(item.city_support ? item.city_support : '--'))])]), _vm._v(" "), _c('div', {
      staticClass: "cpoint",
      staticStyle: {
        "margin": "8px 10px",
        "width": "50%"
      },
      on: {
        "click": function($event) {
          return _vm.toout(item.area_support_href)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t区："), _c('span', {
      staticStyle: {
        "color": "#0070c0"
      }
    }, [_vm._v(_vm._s(item.area_support ? item.area_support : '--'))])])]) : _vm._e(), _vm._v(" "), (item.showz) ? _c('div', {
      staticClass: "box5_text2 text-center",
      staticStyle: {
        "min-width": "250px",
        "justify-content": "center",
        "text-align": "left"
      }
    }, [_c('div', [_vm._v("见政策详情")])]) : _vm._e()])
  }), _vm._v(" "), (!_vm.newlist.length) ? _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1) : _vm._e()], 2) : _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 0)
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text1  text-center  text-bold",
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 justify-center justify-center  text-bold"
  }, [_vm._v("政策类别")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold justify-center"
  }, [_vm._v("政府补贴项目名称")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold justify-center"
  }, [_vm._v("课题名称")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold justify-center width-80",
    staticStyle: {
      "flex": "none"
    }
  }, [_vm._v("\n\t\t\t\t年份\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold justify-center",
    staticStyle: {
      "min-width": "250px"
    }
  }, [_vm._v("\n\t\t\t\t补贴金额（万元）\n\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30d790b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company/components/policy-page.vue
// module id = 886
// module chunks = 1